import {FaHandshake, FaHistory, FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const alertListURL = getUrl("getAlertsList");
export const sensorAlertListURL = getUrl("getSensorAlertsList");

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_alertdefinition"]},
  {label: "History", icon: FaHistory, perms: []},
  {label: "Handoff", icon: FaHandshake, perms: []},
  {label: "Delete", icon: FaTrash, perms: ["delete_alertdefinition"]},
];

export const getListHeaders = (isStaffOrSuperuser) => [
  "id",
  "type",
  "name",
  "level",
  ...(isStaffOrSuperuser ? ["user_email"] : []),
  "site_name",
  "location_name",
  "appliance",
  "enabled",
  "sms_notifications",
  "updated_at",
];

export const CUSTOM_RENDER_KEYS = ["sms_notifications"];
